/**
 * Safe setTimeout wrapper that ensures non-negative delays
 * Prevents TimeoutNegativeWarning errors in development
 */
export function safeSetTimeout(
	callback: () => void,
	delay: number,
): NodeJS.Timeout {
	// Ensure delay is at least 1ms to prevent negative timeout warnings
	const safeDelay = Math.max(1, delay);
	
	if (delay < 0 && process.env.NODE_ENV === "development") {
		console.warn(
			`Attempted to set timeout with negative delay: ${delay}ms. Using 1ms instead.`,
		);
	}
	
	return setTimeout(callback, safeDelay);
}

/**
 * Calculate safe delay between two dates/times
 * Returns at least 1ms to prevent negative timeouts
 */
export function calculateSafeDelay(
	targetTime: Date | number,
	currentTime: Date | number = Date.now(),
): number {
	const target = targetTime instanceof Date ? targetTime.getTime() : targetTime;
	const current = currentTime instanceof Date ? currentTime.getTime() : currentTime;
	
	return Math.max(1, target - current);
}